import { Chip } from '@lifebit-ai/lds'
import React from 'react'

interface BracketTagProps {
  isOpening: boolean
}

export const BracketTag = ({ isOpening }: BracketTagProps): JSX.Element => {
  return (
    <Chip withFixedWidth data-testid="bracket-tag" content={[{ type: 'secondary', value: isOpening ? '(' : ')' }]} />
  )
}
